import { EquipmentModel } from '../../models/complex/equipment.model';
import { MatSerNumber } from '../../types/equipment';

/**
 * The key the slice caches an equipment's licences under, for callers holding the equipment as
 * plain state — the store slices and their effects.
 *
 * @param equipment
 */
export function softwareLicenceEquipmentKeyForState(equipment: MatSerNumber): string {
    return `${equipment.matnr}-${equipment.sernr}`;
}

export function softwareLicenceEquipmentKey(equipment: EquipmentModel): string {
    return softwareLicenceEquipmentKeyForState({ matnr: equipment.matnr.value, sernr: equipment.sernr.value });
}
